import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TravelForm from './TravelForm';
import { Alert, AlertTitle, Box, Collapse, FormControlLabel, IconButton, Stack, Switch } from '@mui/material';
import { Close } from '@mui/icons-material';
import Navbar from './Navbar';
import Hideable from './Hideable';
import Location from './Location';


const GpsEnabler = props => {
      return (
            <Hideable hidden={props.gpsEnabled}>
                  <Alert variant='standard' severity='warning'>
                        <AlertTitle>Enable GPS</AlertTitle>
                        <p>
                              Enable GPS to get an accurate real-time forecast.
                        </p>
                        <FormControlLabel control={
                              <Switch
                                    checked={Location.isGpsEnabled()}
                                    onChange={() =>{
                                          props.setGpsEnabled(true)
                                    }}
                                    />
                        } label="GPS" />
                  </Alert>
            </Hideable>
      )
}

const Home = props => {
  document.title = `navscout`;
  const [dismissUpdateNotification, setDismissUpdateNotification] = useState(false);
  const navigate = useNavigate();

  return (
    <Box>
      <Collapse in={window.notifyNewUpdate && !dismissUpdateNotification}>
            <Alert
            action={
                  <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                        window.notifyNewUpdate = false;
                        setDismissUpdateNotification(true)
                  }}
                  >
                  <Close fontSize="inherit" />
                  </IconButton>
            }
            sx={{ mb: 2 }}>
                  A new update is available, close the application to update it.
            </Alert>
      </Collapse>
      <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
      <Navbar client={props.client} account={props.account} onError={props.onError} large gpsEnabled={props.gpsEnabled} setGpsEnabled={props.setGpsEnabled} />
      </div>
      <GpsEnabler gpsEnabled={props.gpsEnabled} setGpsEnabled={props.setGpsEnabled} />
      <p style={{fontSize: '1.5em'}}>
      Get real-time weather information for your travels.
      </p>
      <TravelForm 
            basic={true} 
            client={props.client} 
            account={props.account} 
            onSave={travel => {navigate(`/drive/${travel.id}`)}}
            />

      <Box
            sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            // backgroundColor: 'primary.main', // Example styling
            // color: 'white',
            padding: (theme) => theme.spacing(2),
            textAlign: 'center',
            }}
            >
            <Stack
                  justifyContent="center" // Centers items horizontally
                  alignItems="center"     // Centers items vertically
                  direction='row' 
                  spacing={2}
                  >
                  <Link to='/about'>About</Link><br/>
                  <Link to='/about/privacy'>Privacy</Link><br/>
                  <Link to='/about/terms-of-service'>Terms</Link><br/>
                  {/* <a href='https://store.app/navscout'>store.app</a> */}
            </Stack>
      </Box>
    </Box>
  )
}


export default Home;